export type TremendousProductSku = {
  min: number;
  max: number;
  currencyCodes: string[];
};

export type TremendousProduct = {
  id: string;
  name: string;
  description?: string;
  category: string;
  subcategory?: string;
  disclosure?: string;
  countries: string[];
  currencyCodes?: string[];
  skus: TremendousProductSku[];
  imageUrl?: string;
};

export type TremendousProductSearchPayload = {
  query?: string;
  category?: string;
  country?: string;
  limit?: number;
};

export type TremendousProductSearchResponse = {
  products: TremendousProduct[];
};

export type TremendousRewardProductMetadata = {
  productId: string;
  productNameSnapshot: string;
  brandName?: string;
  category: string;
  subcategory?: string;
  currencyCode: string;
  denomination: number;
  skuMin: number;
  skuMax: number;
  countries: string[];
  imageUrl?: string;
  descriptionSnapshot?: string;
  disclosure?: string;
};

export const TREMENDOUS_PRODUCT_CATEGORIES = [
  "ach",
  "cash_app",
  "charity",
  "instant_debit_transfer",
  "merchant_card",
  "paypal",
  "venmo",
  "visa_card",
] as const;
